export default __webpack_public_path__ + "static/media/cotCover.c80b2ca5.jpg";